module.exports = __webpack_public_path__ + "img/shop2.12ff790c.png";